import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
/* import { me } from '../services/api/ApiManager'; */
import { saveRole, saveUser } from '../store/slices/userSlices';
import { ApiManager } from '../services/api';
import { SplashScreen } from '../components';

const AuthContext = React.createContext();

function AuthProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(undefined);
  const [waitAuthCheck, setWaitAuthCheck] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoading) {
      me();
    }

    async function me() {
      const res = await ApiManager.me();
      if (res?.status === 200 && res?.data?.data) {
        success(res?.data?.data);
      } else {
        pass(res);
      }
    }
    function success(data) {
      Promise.all([
        dispatch(saveUser(data || null)),
        dispatch(saveRole(data?.role || null)),
        // You can receive data in here before app initialization
      ]).then((values) => {
        setWaitAuthCheck(false);
        setIsAuthenticated(true);
      });
    }

    function pass(message) {
      setWaitAuthCheck(false);
      setIsAuthenticated(false);
    }
  }, [dispatch, isLoading]);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  return waitAuthCheck ? (
    <SplashScreen />
  ) : (
    <AuthContext.Provider value={{ isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
}

function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProviderComponent');
  }
  return context;
}

export { AuthProvider, useAuth };
